export default {
  heading: 'Member-made to power life outside',
  pillars: [
    {
      image: {
        alt: 'REI Co-op Member Erik V. takes a selfie during an afternoon roadside run.',
        src: 'https://www.rei.com/dam/21222585_pillar1.png',
      },
      heading: 'Save',
      body: 'time, money and more',
      cta: 'Explore the benefits',
      key: '0',
      modalModel: {
        heading: 'Save time, money, and more',
        bodyHTML: `
          <p>When you join the co-op, you get more outside:<p>
          <ul>
            <li>Free shipping with no minimum order</li>
            <li>A full year for most returns</li>
            <li>10% Co-op Member Reward on eligible, full-price purchases</li>
            <li>Coupons for gear and discounts on shop services and classes</li>
            <li>And lots more</li>
          </ul>`,
      },
    }, {
      image: {
        alt: 'REI Co-op Members Chelsea, Erin Joy and Samara pause on a crisp fall hike to enjoy the vast landscape of a remote desert lake.',
        src: 'https://www.rei.com/dam/21222588_pillar2.png',
      },
      heading: 'Shape',
      body: 'the path of the co-op',
      cta: 'Use your voice',
      key: '1',
      modalModel: {
        heading: 'Shape the path of the co-op',
        bodyHTML: `
          <p>Your voice matters in shaping product we make, the stories we tell, and the future of the co-op!</p>
          <ul>
            <li>Use hashtag <strong>#REIMember</strong> on social media and we may share your story</li>
            <li><a href="https://reicasting.com">Sign up</a> to be considered as a model or crew for an upcoming photo or video production</li>
            <li><a href="https://reicasting.atellio.com/app/reicasting/p/callouts/7cdf36b8-e631-4325-b8f8-5a0f6363b02e">Share your story</a> and we may feature you</li>
            <li><a href="https://www.rei.com/help/rei-email-subscription">Opt in to email</a> and you might be selected for a survey to give feedback on product design</li>
            <li><a href="https://www.rei.com/about-rei/board-of-directors#faq-0-accordion">Vote</a> for the co-op’s Board of Directors each spring</li>
          </ul>`,
      },
    }, {
      image: {
        alt: 'REI Co-op Member Angela R. and friend playfully pose under a canyon waterfall during a summer hike.',
        src: 'https://www.rei.com/dam/21222586_pillar3.png',
      },
      heading: 'Change',
      body: 'the future of the outdoors',
      cta: 'Make an impact',
      key: '2',
      modalModel: {
        heading: 'Change the future of the outdoors',
        bodyHTML: `
          <p>Your ability to make change in the world gets even stronger when you become a member of the co-op</p>
          <ul>
            <li>REI donates $5 to the <a href="https://www.reifund.org/">REI Cooperative Action Fund</a> for every new member who joins</li>
            <li>Participate in the <a href="/action/network">Cooperative Action Network</a> to advocate for policies that protect the outdoors for everyone</li>
            <li>Shop <a href="/used">Re/Supply</a> to keep gear and apparel out of landfills</li>
          </ul>
        `,
      },
    },
  ],
};
